import { render, staticRenderFns } from "./TutorialsSetting.vue?vue&type=template&id=334bab3c&scoped=true&"
import script from "./TutorialsSetting.vue?vue&type=script&lang=js&"
export * from "./TutorialsSetting.vue?vue&type=script&lang=js&"
import style0 from "./TutorialsSetting.vue?vue&type=style&index=0&id=334bab3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334bab3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
